export type RearrangeRefusedReason =
	| 'locked-island-no-room'
	| 'exceeds-max-width'
	| 'nothing-to-move'
	| 'not-movable';

/**
 * Thrown by the rearrange primitives BEFORE anything is mutated. A caller
 * (the 3D drop, a tool) turns it into a refused drop or a tool error.
 */
export class RearrangeRefusedError extends Error {
	readonly reason: RearrangeRefusedReason;

	constructor (reason: RearrangeRefusedReason, message: string) {
		super(message);
		this.name = 'RearrangeRefusedError';
		this.reason = reason;
	}
}

export interface IslandResize {
	islandId: string;
	fromWidthIn: number;
	toWidthIn: number;
}

export interface RearrangeGrowthOptions {
	/**
	 * Whether the receiving island may grow to make room. Defaults to
	 * `!island.sizeLocked`; the app narrows it with its own fixed-type list.
	 */
	growable?: boolean;
	/** Soft cap for a grown island (inches); null or undefined = no cap */
	maxWidth?: number | null;
}

export interface MoveGroupToPanelResult {
	/** The column's id — preserved across the move */
	groupId: string;
	/** Item ids carried over (companions the rules regenerate are not listed) */
	movedIds: Array<string>;
	resized: IslandResize | null;
}

export interface SwapGroupsAcrossPanelsResult {
	movedIds: Array<string>;
	resized: Array<IslandResize>;
}
